import { useForm, useWatch } from "react-hook-form";
import { TextInput } from "../../form";
import { useDebounced } from "../../hooks";
import { useTranslation } from "../../localization";
import { useFileExplorerContext } from "./context";

export function FileExplorerSearch() {
	/** Context */
	const { setSearchValue } = useFileExplorerContext();

	/** Hooks */
	const methods = useForm<{ search: string }>({
		defaultValues: {
			search: "",
		},
	});
	const searchValue = useWatch({ control: methods.control, name: "search" });

	/** Hooks */
	const { t } = useTranslation();
	const { isDebouncing } = useDebounced({
		value: searchValue,
		fn: setSearchValue,
		timeout: 500,
	});

	/** Render */
	return (
		<div className="w-[400px]">
			<TextInput
				label={undefined}
				className="input"
				placeholder={t("placeholders.search")}
				control={methods.control}
				name="search"
				type="search"
				isRequired={false}
				data-cy="data-table-search-input"
				isLoading={isDebouncing}
			/>
		</div>
	);
}
